import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import KendoDropDownHelper from '@/Utility/KendoDropDownHelper';

export default class MultiSelectAutoCompleteViewModel extends ControlViewModel {

    /**
     * Die ausgewählten Werte
     * Entspricht bei komplexen Typen dem Wert des "dataValueField"
     */
    public values: KnockoutObservable<any[]>

    /**
     * Gibt an, ob im "ContainsMode" gesucht werden soll
     */
    public containsMode: boolean;

    /**
     * Gibt die minimale Anzahl Zeichen an, die eingegeben werden müssen bevor gesucht wird
     */
    public minLength: KnockoutObservable<number>;

    /**
     * Gibt die minimale Anzahl an selektierbaren Objekten an
     */
    public maxSelectedItems: KnockoutObservable<any>;

    /**
     * Das Feld, welches angezeigt wird
     */
    public dataTextField: any;

    /**
     * Das Feld, welches den Wert beinhaltet
     */
    public dataValueField: any;

    /**
     * Ein Template zur Formatierung des ausgewählten Objekts
     */
    public template: KnockoutObservable<any>;

    /**
     * Ein Template zur Formatierung der auswählbaren Objekte
     */
    public valueTemplate: KnockoutObservable<any>;

    /**
     * Die aktuelle Datenquelle
     */
    public dataSource: any;

    /**
     * Wird aufgerufen, sobald ein Objekt hinzugefügt wird
     */
    public onConnect: Function;

    /**
     * Wird aufgerufen, sobald ein Objekt entfernt wird
     */
    public onDisconnect: Function;

    /**
     * Wird aufgerufen, sobald eine Eingabe vorgenommen wird
     */
    public onType: Function;

    /**
     * Wird aufgerufen, sobald ein Objekt selektiert wird
     */
    public onSelect: Function;

    /**
     * Wird aufgerufen, sobald das selektierte Objekt gewechselt wird
     */
    public onChange: Function;

    public onOpen: Function;

    public dataBound: Function;

    /**
     * Tooltip wird hier überschrieben 
     */
    public tooltip: LabelViewModel;

    /**
     * Das ViewModel für die MultiSelectAutoComplete
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.values = this.observableOrDefault(params.values, []);
        this.containsMode = this.paramOrDefault(params.containsMode, true);
        this.minLength = this.observableOrDefault(params.minLength, 1);
        this.maxSelectedItems = this.observableOrDefault(params.maxSelectedItems, null);
        this.dataTextField = this.paramOrDefault(params.dataTextField, null);
        this.dataValueField = this.paramOrDefault(params.dataValueField, null);
        this.template = this.observableOrDefault(params.template, null);
        this.valueTemplate = this.observableOrDefault(params.valueTemplate, null);
        this.dataSource = this.paramOrDefault(params.dataSource, null);
        this.onConnect = this.handlerOrDefault(params.onConnect);
        this.onDisconnect = this.handlerOrDefault(params.onDisconnect);
        this.onType = this.handlerOrDefault(params.onType);
        this.dataBound = this.handlerOrDefault(params.dataBound);

        this.onSelect = this.handlerOrDefault((event) => {
            let data = this.dataSource.data();
            let index = event.item.index();
            let connected = data[index][this.dataValueField];

            if (connected != null) {
                this.onConnect(connected);
            }
        });

        this.onChange = this.handlerOrDefault((e: any) => {
            let widget = e.sender; // e.sender ist das kendo.ui.MultiSelect Widget
            let selected = widget.value();
            let previousSelected = this.values();
            let disconnected = null;

            for (let j = 0; j < previousSelected.length; j++) {
                if (selected.indexOf(previousSelected[j][this.dataValueField]) === -1) {
                    disconnected = previousSelected[j][this.dataValueField];
                }
            }

            if (disconnected != null) {
                this.onDisconnect(disconnected);
            }
        });

        this.onOpen = this.handlerOrDefault(params.onOpen, () => {
        });

        this.tooltip = new LabelViewModel({
            caption: KendoDropDownHelper.createComputedTooltip(params.tooltip?.caption || '', 
                null, this.values, this.dataTextField, this.dataValueField, 
                (sub) => this.subscriptionCollection.push(sub))
        });
    }
}

ComponentManager.setViewModel('MultiSelectAutoCompleteViewModel', MultiSelectAutoCompleteViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');